import { InvoiceTicket } from './invoice-ticket';
export class GasTravel {
    id: number = 0;
    user_id : number = 0;
    travel_id: number = 0;
    gasticket: number = 0;
    description: string;
    gas_date: any = 0;  
    metric_final: number = 0;
    metric_initial: number = 0;
    metric_real: number = 0;
    is_refill: boolean = false;
    type: string;
    gas_type: string;
    updated_at: any;
    created_at: any;
    length : number ;
    unity_id:number = 0;
    user_name: string = '';
    sap_code:string = '';
    sap_project:string = '';
    invoice_number: string = '';
    enterprise:string = '';
    invoice_ticket_id:number = 0;
    status: string = '';
}
